import { useTranslation } from "react-i18next";
import { CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined, ReloadOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Form, Input, Modal, Row, Space, Spin } from "antd";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    OrganizationAdminCreateRequest,
    OrganizationAdminUpdateRequest,
    UserAccountOrganizationCreateRequestDto
} from "../api/client-axios";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { addOrganizationAdmin, clearErrorOrganizationAdmin, getOrganizationAdmin, initOrganizationAdmin, setErrorOrganizationAdmin, updateOrganizationAdmin, updateOrganizationAdminFields, updateOrganizationAdminPassword } from "../features/organizationAdminSlice";
import { Problem } from "../model/problem";
import { getErrorMessage } from "../utils/getErrorMessage";
import { RouteNames } from "../routes";

export const EditOrganizationAdminPage = () => {
    const params = useParams();
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const status = useAppSelector(state => state.organizationAdmin.status);
    const organizationAdmin = useAppSelector(state => state.organizationAdmin.admin);
    const password = useAppSelector(state => state.organizationAdmin.password);
    const error = useAppSelector(state => state.organizationAdmin.error);
    const navigate = useNavigate();


    console.log("render", organizationAdmin);

    useEffect(() => {
        if (params.adminId === "new") {
            dispatch(initOrganizationAdmin());
            return;
        }

        if (params.adminId != null && params.organizationId != null) {
            dispatch(getOrganizationAdmin({ organizationId: params.organizationId, id: params.adminId }));
        }
    }, []);

    useEffect(() => {
        if(status === "saved") {
            navigate(`/${RouteNames.organizations}/${params.organizationId}`);
        }
    },[status])

    const organizationId = params.organizationId;
    const adminId = params.adminId;
    const isAdd = adminId === "new";

    const onCancel = () => {
        navigate(-1);
    };

    const isValidPassword = () => {
        
       const result = password != null && password.password.length > 7 && password.password === password.confirmPassword;
       if(!result) {
           dispatch(setErrorOrganizationAdmin({
            title: t("error.passwordValidation.title"),
            detail: t("error.passwordValidation.detail")
           } as Problem));
       }
       return result;
    }

    const onSave = () => {
        if (organizationId == null || organizationAdmin == null) return;

        if (isAdd && isValidPassword()) {
            dispatch(addOrganizationAdmin({
                organizationId: organizationId,
                admin: {
                    firstName: organizationAdmin.firstName,
                    lastName: organizationAdmin.lastName,
                    userAccountId: organizationAdmin.userAccountId,
                    password: password.password,
                    userAccount: {
                        emailAddress: organizationAdmin.userAccount?.emailAddress,
                        mobileNumber: organizationAdmin.userAccount?.mobileNumber
                    } as UserAccountOrganizationCreateRequestDto

                } as OrganizationAdminCreateRequest
            }));
            return;
        }


        if (organizationAdmin.id == null) return;

        dispatch(updateOrganizationAdmin({
            organizationId: organizationId,
            id: organizationAdmin.id!,
            admin: {
                firstName: organizationAdmin.firstName,
                lastName: organizationAdmin.lastName
            } as OrganizationAdminUpdateRequest
        }));
    }

    const buttons = <Row className="" >
        <Col span={24}>
            <Row justify="end">
                <Space>
                    <Button type='text' icon={<CloseOutlined />} onClick={onCancel} >{t("actions.cancel")}</Button>
                    <Button type='primary' icon={<PlusOutlined />} onClick={onSave}>{t("actions.save")}</Button>
                </Space>

            </Row>
        </Col>

    </Row>;


    const errorMessage = getErrorMessage(error);

    const passwordFields = isAdd ? <div>
        <Col span={24}>
            <Form.Item label={t("field.password")} rules={[{ required: true }]} initialValue={password?.password}>
                <Input type="password" placeholder={t("placeholder.passwordMask")} onChange={(e) => dispatch(updateOrganizationAdminPassword({ ...password, password: e.target.value }))} />
            </Form.Item>
        </Col>
        <Col span={24}>
            <Form.Item label={t("field.repeatPassword")} rules={[{ required: true }]} initialValue={password?.confirmPassword}>
                <Input type="password" placeholder={t("placeholder.passwordMask")} onChange={(e) => dispatch(updateOrganizationAdminPassword({ ...password, confirmPassword: e.target.value }))} />
            </Form.Item>
        </Col>
    </div> : <div />;

    const content = status === "loading" || status === "idle" ? <Spin className="flex-center mt-xxl" /> : <Form className='mt-s'
        name="basic"
        labelCol={{ span: 3 }}
        wrapperCol={{ span: 22 }}
        initialValues={{ remember: true }}
        autoComplete="off"
    >
        <Col span={24}>
            <Form.Item label={t("field.firstName")} rules={[{ required: true }]} >
                <Input  defaultValue={organizationAdmin?.firstName ?? ""} placeholder={t("placeholder.firstName")}  onChange={(e) => dispatch(updateOrganizationAdminFields({ ...organizationAdmin, firstName: e.target.value }))} />
            </Form.Item>
        </Col>
        <Col span={24}>
            <Form.Item label={t("field.lastName")} rules={[{ required: true }]}>
                <Input  defaultValue={organizationAdmin?.lastName ?? ""} placeholder={t("placeholder.lastName")} onChange={(e) => dispatch(updateOrganizationAdminFields({ ...organizationAdmin, lastName: e.target.value }))} />
            </Form.Item>
        </Col>
        <Col span={24}>
            <Form.Item label={t("field.email")} rules={[{ required: true }]} >
                <Input defaultValue={organizationAdmin?.userAccount?.emailAddress ?? ""} disabled={!isAdd} placeholder={t("placeholder.emailShort")} onChange={(e) => dispatch(updateOrganizationAdminFields({ ...organizationAdmin, userAccount: { ...organizationAdmin?.userAccount, emailAddress: e.target.value } }))} />
            </Form.Item>
        </Col>
        {passwordFields}
    </Form>;



    return (
        <div className="edit-person-main-frame">
            {buttons}
            {content}
            <Modal title={errorMessage.title} visible={status === 'error' || status === 'auth-error'} onOk={() => dispatch(clearErrorOrganizationAdmin())} cancelButtonProps={{ hidden: true }}>
                {errorMessage.details}
            </Modal>
        </div>
    );
}